import { render, staticRenderFns } from "./SpaceEventTypes.vue?vue&type=template&id=454e52e1"
import script from "./SpaceEventTypes.vue?vue&type=script&lang=js"
export * from "./SpaceEventTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports